$.extend($.validator.messages, {
    required: Alkami.Localization.SiteText['jQuery.validator.messages.required'],
    remote: Alkami.Localization.SiteText['jQuery.validator.messages.remote'],
    email: Alkami.Localization.SiteText['jQuery.validator.messages.email'],
    url: Alkami.Localization.SiteText['jQuery.validator.messages.url'],
    date: Alkami.Localization.SiteText['jQuery.validator.messages.date'],
    number: Alkami.Localization.SiteText['jQuery.validator.messages.number'],
    digits: Alkami.Localization.SiteText['jQuery.validator.messages.digits'],
    creditcard: Alkami.Localization.SiteText['jQuery.validator.messages.creditcard'],
    equalTo: Alkami.Localization.SiteText['jQuery.validator.messages.equalTo'],
    maxlength: $.validator.format(Alkami.Localization.SiteText['jQuery.validator.messages.maxlength']),
    minlength: $.validator.format(Alkami.Localization.SiteText['jQuery.validator.messages.minlength']),
    rangelength: $.validator.format(Alkami.Localization.SiteText['jQuery.validator.messages.rangelength']),
    range: $.validator.format(Alkami.Localization.SiteText['jQuery.validator.messages.range']),
    max: $.validator.format(Alkami.Localization.SiteText['jQuery.validator.messages.max']),
    min: $.validator.format(Alkami.Localization.SiteText['jQuery.validator.messages.min'])
});